import React from 'react';
import { CaretDownFilled } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Checkbox, Dropdown } from 'antd';
import styled from 'styled-components';
import {
  primaryFont, primaryHeadingColor, SecondaryColor, wMedium,
} from 'Utils/utilsStyle';
import ViewIconCollab from 'Components/common/assets/svgIcons/ViewIconCollab';
import EditIconCollab from 'Components/common/assets/svgIcons/EditIconCollab';
import StopAccessIcon from 'Components/common/assets/svgIcons/StopAccessIcon';
import classNames from 'classnames';
import { FolderAccessType } from 'Types/DocumentHubTypes';

const StyleDropdown = styled(Dropdown)`
&.drop-down-button {
  &.ant-dropdown-open {
    .drop-down-icon {
      svg {
        rotate: 180deg;
      }
  }
  }
  display: flex;
  align-items: center;
  margin-right: 8px;
  cursor: pointer;
  .drop-down-text {
    color: ${primaryHeadingColor};
    font-family: ${primaryFont};
    font-size: 14px;
    font-weight: ${wMedium};
    line-height: 22px;
    letter-spacing: -0.45px;
    margin-bottom: 0;
    margin-right: 6px;
    white-space: pre;
  }
  .drop-down-icon {
    svg {
      fill: ${primaryHeadingColor};
    }
  }
  .ant-dropdown {
    width: 188px;
    .ant-dropdown-menu {
      border-radius: 8px;
      padding: 4px 0px;
      .ant-dropdown-menu-item {
        &.ant-dropdown-menu-item-disabled {
           &:hover {
            .ant-dropdown-menu-title-content {
            .dropdown-item {
              .ant-checkbox-wrapper {
                .ant-checkbox {
                  .ant-checkbox-inner {
                    background-color: #fff;
                  }
                }
              }
            }
           }
          .ant-dropdown-menu-title-content {
            .dropdown-item {
              .ant-checkbox-wrapper {
                .ant-checkbox {
                  .ant-checkbox-input {
                    cursor: not-allowed;
                  }
                }
              }
            }
          }
        }
      }
        display: flex;
        align-items: flex-start;
        &:hover {
          .ant-dropdown-menu-title-content {
          .dropdown-item {
            .ant-checkbox-wrapper {
              .ant-checkbox {
                .ant-checkbox-inner {
                  background-color: #f5f5f5;
                }
              }
            }
          }
        }
        }
          padding-left: 30px;
          svg {
            margin: 4px 6px;
            width: 18px;
            height: 18px;
          }
        .ant-dropdown-menu-title-content {
          .dropdown-item {
            .ant-checkbox-wrapper {
              &:hover {
                .ant-checkbox::after {
                  border: 0px;
                }
              }
              height: 20px;
              width: fit-content;
              position: absolute;
              left: 12px;
              top: 8px;
              margin-bottom: 0;
              .ant-checkbox {
                .ant-checkbox-inner {
                  border: 0 !important;
                }
              }
            }
            .dropdown-title {
              display: flex;
              flex-direction: column;
              .main-title {
                color: ${SecondaryColor};
                font-family: ${primaryFont};
                font-size: 16px;
                font-weight: ${wMedium};
                line-height: 24px;
                letter-spacing: -0.28px;
              }
              .sub-title {
                color: #67696A;
                font-family: ${primaryFont};
                font-size: 14px;
                font-weight: ${wMedium};
                line-height: 18px;
                letter-spacing: -0.28px;
              }
            }
          }
        }
      }
    }
  }
}
`;

type Props = {
  disabled: boolean;
  tickedType: FolderAccessType
  onClick: (a: FolderAccessType) => void
};

const ManageAccessDropdown = function ManageAccessDropdown(props: Props) {
  const { disabled, tickedType, onClick } = props;

  const items: MenuProps['items'] = [
    {
      key: '1',
      label: (
        <div className="dropdown-item">
          <Checkbox checked={tickedType === 'view'} />
          <span className="dropdown-title">
            <span className="main-title">
              View
            </span>
            <span className="sub-title">
              Can view only
            </span>
          </span>
        </div>
      ),
      icon: <ViewIconCollab />,
      disabled: tickedType === 'view',
      onClick: () => onClick('view'),
    },
    {
      key: '2',
      label: (
        <div className="dropdown-item">
          <Checkbox checked={tickedType === 'edit'} />
          <span className="dropdown-title">
            <span className="main-title">
              Edit
            </span>
            <span className="sub-title">
              Can make changes
            </span>
          </span>
        </div>
      ),
      icon: <EditIconCollab />,
      disabled: tickedType === 'edit',
      onClick: () => onClick('edit'),
    },
    {
      key: '3',
      label: (
        <div className="dropdown-item">
          <Checkbox checked={tickedType === 'remove'} />
          <span className="dropdown-title">
            <span className="main-title">
              Remove Access
            </span>
            <span className="sub-title">
              Can not access
            </span>
          </span>
        </div>
      ),
      icon: <StopAccessIcon />,
      disabled: tickedType === 'remove',
      onClick: () => onClick('remove'),
    },
  ];

  return (
    <StyleDropdown
      menu={{ items }}
      placement="bottomRight"
      trigger={['click']}
      getPopupContainer={(e: HTMLElement) => e}
      className={classNames({ disabled })}
    >
      <div className="drop-down-button">
        <div tabIndex={0} role="button" className="drop-down-text">
          {tickedType === 'edit' ? 'Edit' : tickedType === 'view' ? 'View' : 'Remove Access'}
        </div>
        <CaretDownFilled className="drop-down-icon" />
      </div>
    </StyleDropdown>
  );
};

export default ManageAccessDropdown;
